/**
 * Landing page assets configuration
 * Videos are hosted on Supabase Storage in the 'landing-assets' public bucket
 */

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL

/**
 * Public URLs for landing page videos
 * All videos are WebM format, optimized for web playback
 */
export const LANDING_VIDEOS = {
  /** Hero animation - 10s loop, 500x400px */
  hero: `${SUPABASE_URL}/storage/v1/object/public/landing-assets/videos/hero.webm`,

  /** NicolAI demo walkthrough - 20s loop, 900x450px */
  nicolaiDemo: `${SUPABASE_URL}/storage/v1/object/public/landing-assets/videos/nicolai-demo.webm`,

  /** How It Works step animations - 3s loop each, 80x80px */
  steps: {
    shareVision: `${SUPABASE_URL}/storage/v1/object/public/landing-assets/videos/step1.webm`,
    getChallenged: `${SUPABASE_URL}/storage/v1/object/public/landing-assets/videos/step2.webm`,
    watchItForm: `${SUPABASE_URL}/storage/v1/object/public/landing-assets/videos/step3.webm`,
    ownYourSpecs: `${SUPABASE_URL}/storage/v1/object/public/landing-assets/videos/step4.webm`,
  },
} as const

/**
 * Landing page section IDs for smooth scrolling navigation
 */
export const LANDING_SECTIONS = {
  hero: 'hero',
  howItWorks: 'how-it-works',
  nicolai: 'nicolai',
  pricing: 'pricing',
  faq: 'faq',
  cta: 'cta',
} as const

/**
 * Scroll to a landing page section with smooth behavior
 */
export function scrollToSection(sectionId: string): void {
  const element = document.getElementById(sectionId)
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
